import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';

import { LoginLayout } from 'components';

export const ResetPasswordSuccess = ({ t }) => (
  <LoginLayout
    title={t('login.resetPassword.success.title')}
    description={t('login.resetPassword.success.description')}
  >
    <Link className="button button--full" to="/login-email">
      {t('login.resetPassword.success.backToLogin')}
    </Link>
  </LoginLayout>
);

ResetPasswordSuccess.propTypes = {
  t: PropTypes.func.isRequired
};

export default translate()(ResetPasswordSuccess);



// WEBPACK FOOTER //
// ./src/components/ResetPasswordSuccess/ResetPasswordSuccess.js